module.exports = __webpack_public_path__ + "3fd89c851efee4acb0ec7125ca099cf7.jpg";